import PropTypes from 'prop-types'
import React from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Icon from 'components/Icon'
import { Text } from 'styles/components/typography'

import './FaqGutContent.scss'

const BACTERIAS = ['old', 'high', 'bomb', 'old', 'caterpillar']

/**
 * Component of FAQ Gut content. Used within FaqGut component
 * @return {Component} Component — FaqGutContent
 */
const FaqGutContent = ({ content, activeIndex }) => {
  const className = 'faq-gut__content-description bg--picton-blue text--white'

  return (
    <div className="faq-gut__content col-md-6 col-lg-5">
      <TransitionGroup component={null}>
        <CSSTransition
          classNames="faq-gut__content-description-"
          key={activeIndex}
          timeout={{ enter: 400, exit: 700 }}
        >
          {status => (
            <div className={`${className} ${status} p-2 pl-md-3 pr-md-3`}>
              <Text dangerouslySetInnerHTML={{ __html: content.content }} />
              <Icon
                className="faq-gut__content-icon"
                id={`color_bacteria_${BACTERIAS[activeIndex]}`}
              />
            </div>
          )}
        </CSSTransition>
      </TransitionGroup>
    </div>
  )
}

FaqGutContent.propTypes = {
  /** Index of active tab */
  activeIndex: PropTypes.number.isRequired,

  /** Content of Item */
  content: PropTypes.object.isRequired,
}

export default FaqGutContent
